/**
 * UI density (comfortable | compact) — localStorage-only.
 *
 * Applica la classe `density-compact` su `<html>` quando attiva; lo
 * style globale in `globals.css` rimpicciolisce padding/altezza riga
 * delle tabelle e dei card. Il default e' "comfortable" (no classe).
 */

export type Density = "comfortable" | "compact";

const STORAGE_KEY = "dpanel:ui:density";

export function readDensity(): Density {
  if (typeof window === "undefined") return "comfortable";
  const raw = window.localStorage.getItem(STORAGE_KEY);
  return raw === "compact" ? "compact" : "comfortable";
}

export function applyDensity(d: Density): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(STORAGE_KEY, d);
  document.documentElement.classList.toggle("density-compact", d === "compact");
}

export function initDensity(): void {
  applyDensity(readDensity());
}
